import { createStore } from 'vuex'
import taskPaper from './modules/taskPaper'
import star3Note from './modules/star3Note'
export default createStore({
  modules: {
    taskPaper,
    star3Note
  },
  state: {
    questionIds: [],
    questionData: [],
    collectionInfo: [],
    actionBarHeight: 0,
    clientCommonMessage: {
        height: 0,
        service_version: "14",
        service_version_name: "1.8.0",
        tal_id: "Talo-kgKmTJcXYqqKdvapn68Gg",
        token: "tal173jtAFOUs1DViRWwVKhnfMU1Bdnu2oSKpWDtmEeu8Xgw4yqHcI-8vzsl5LjjjO7RGtcbngaFhReWoCZC2Q_xdjNA5UqQYiIRF-XRptKGKpuRvpIfaPdwJtMoYtS9UAw6W5E7vA2n3Ygu7cLTZcJ34Hi72VMAbggXC2hiPsI19fvM8fm_pYmqw-kskNp-UyPlGwpbA",
        user_id: "HAu8QI/NdJEAUfajaeFfAQ=="
    },
    exerciseReportInfo:{
      score:90,
      questionList:[
        {
          id:1,
          isRight:true
        },
        {
          id:2,
          isRight:true
        },
        {
          id:3,
          isRight:true
        },
      ]
    },
    talqsInteractionConfig: {
      org: '学而思图书', sys: 'xesapp', jobNumber: '22',appkey: process.env.VUE_APP_PREPATH === 'production' ? 'SXOAXZKT' : 'ZYOKDWJS',
    },
    star3NoteList:[]

  },
  getters: {
    questionIds: state => {
      return state.questionIds
    },
    questionData: state => {
      return state.questionData
    },
    collectionInfo: state => {
      return state.collectionInfo
    },
    actionBarHeight: state => state.actionBarHeight,
    clientCommonMessage: state => state.clientCommonMessage,
    talqsInteractionConfig: state => state.talqsInteractionConfig,
    star3NoteList:state => state.star3NoteList
  },
  mutations: {
    SET_QUESTION_IDS: (state, questionIds) => {
      state.questionIds = questionIds
    },
    SET_QUESTION_DATA: (state, questionData) => {
      state.questionData = questionData
    },
    SET_COLLECTIONINFO: (state, collectionInfo) => {
      state.collectionInfo = collectionInfo
    },
    SET_ACTIONBARHEIGHT: (state, actionBarHeight) => {
      state.actionBarHeight = actionBarHeight
    },
    SET_CLIENTCOMMONMESSAGE: (state, clientCommonMessage) => {
      state.clientCommonMessage = clientCommonMessage
    },
    SET_DATA: (state, [key, value]) => {
        state[key] = value
    },
    SET_STAR3_NOTELIST:(state, [key, value]) => {
      state[key] = value
    },
    CONCAT_STAR3_NOTELIST:(state, [key, value]) => {
      // console.log(value,'value')
      state[key] = state[key].concat(value)
      // console.log(state[key],'state[key]')
    },
    DELETE_STAR3_NOTE:(state,[key,value]) => {
      state[key].length && state[key].splice(value,1)
    },
    DELETE_STAR3_NOTE_ALL:(state,[key,value]) => {
      state[key] = []
    }

  },
  actions: {
    setQuestionIds({ commit }, data) {
      commit('SET_QUESTION_IDS', data)
    },
    setQuestionData({ commit }, data) {
      commit('SET_QUESTION_DATA', data)
    },
    setCollectionInfo({ commit }, data) {
      commit('SET_COLLECTIONINFO', data)
    }
  }
})
